export type FinancialGraphState = "loading" | "error" | "empty" | "ready";

export function resolveFinancialGraphState(
  loading: boolean,
  failed: boolean,
  hasData: boolean,
): FinancialGraphState {
  if (loading) return "loading";
  if (failed) return "error";
  return hasData ? "ready" : "empty";
}
